import { z } from 'zod';

export const ViewByOption = z
  .enum(['day', 'week', 'month', 'year'])
  .describe('ViewByOption');

export type ViewByOption = z.infer<typeof ViewByOption>;

export const ViewByOptions = Object.values(ViewByOption.Values);

export const viewByOptionToText: Record<ViewByOption, string> = {
  day: 'Day',
  week: 'Week',
  month: 'Month',
  year: 'Year',
};

export const ViewByDropdownOptions = ViewByOptions.map((option) => ({
  optionValue: option,
  optionLabel: viewByOptionToText[option],
}));
